import React, { useEffect, useState } from "react";
import { getEventosAuditoria } from "../../../../services/auditoria";
import "./AuditoriaActividad.css";

const EVENTOS_HUMANOS = {
  LOGIN_EXITOSO: "inició sesión",
  LOGOUT: "cerró sesión",

  PACIENTE_CREADO: "creó",
  PACIENTE_ACTUALIZADO: "actualizó datos",

  HISTORIA_CREADA: "creó el expediente clínico",
  HISTORIA_ACTUALIZADA: "actualizó el expediente clínico",

  CONSULTA_CREADA: "creó una consulta",
  CONSULTA_ACTUALIZADA: "actualizó la consulta",

  LABORATORIO_AGREGADO: "agregó un laboratorio",
  LABORATORIO_ELIMINADO: "eliminó un laboratorio",

  CITA_CREADA: "creó una cita",
  CITA_ACTUALIZADA: "actualizó una cita",
  CITA_CANCELADA: "canceló una cita",
  RECETA_CREADA: "creó una receta",
  RECETA_EXPORTADA: "exportó una receta",

  CONFIG_RECETA_ACTUALIZADA: "actualizó la configuración de las recetas",
  IMAGEN_RECETA_SUBIDA: "subió una imagen para la receta",

  DOCTOR_ACTUALIZADO: "actualizó sus datos",
};

const CAMPOS_HUMANOS = {
  nombre: "nombre",
  apellido_paterno: "apellido paterno",
  apellido_materno: "apellido materno",
  telefono: "teléfono",
  correo: "correo electrónico",

  antecedentes_padre: "antecedentes del padre",
  antecedentes_madre: "antecedentes de la madre",
  antecedentes_hermanos: "antecedentes de hermanos",
  otros_patologicos: "otros antecedentes patológicos",

  diagnostico: "diagnóstico",
  tratamiento: "tratamiento",
  pronostico: "pronóstico",
  ecd: "Enfermedades Crónico-Degenerativas",

  urlImagenPersonalizada: "imagen personalizada",
  margenYEdad: "margen vertical de edad",
  margenYFechaNacimiento: "margen vertical de fecha de nacimiento",
  margenYMarcaAgua: "margen vertical de marca de agua",
  margenYLineaInferior: "margen inferior",
  margenXSignos: "margen horizontal de signos",
  margenXEdad: "margen horizontal de edad",
  mostrarSignos: "mostrar signos vitales",
  mostrarFechaNacimiento: "mostrar fecha de nacimiento",
  margenYTratamiento: "margen vertical de tratamiento",
  margenYNombrePaciente: "margen vertical del nombre del paciente",
  margenYDiagnostico: "margen vertical de diagnóstico",
  mostrarTA: "presión arterial",
  mostrarFC: "frecuencia cardiaca",
  mostrarFR: "frecuencia respiratoria",
  mostrarTemp: "temperatura",
  mostrarSpO2: "saturación de oxígeno",
  mostrarPeso: "peso",
  mostrarTalla: "talla",
  mostrarIMC: "IMC",
  mostrarClasificacionIMC: "clasificación IMC",
  config_cuestionario:"configuración cuestionario personalizable"
};

const AuditoriaActividad = () => {
  const [eventos, setEventos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchEventos = async () => {
      setLoading(true);
      const data = await getEventosAuditoria();

      if (!data) {
        setError(true);
        setLoading(false);
        return;
      }

      // Soporta backend con o sin paginación
      const eventosData = Array.isArray(data)
        ? data
        : Array.isArray(data.results)
        ? data.results
        : [];

      setEventos(eventosData);
      setLoading(false);
    };

    fetchEventos();
  }, []);

  /* ===============================
     HELPERS DE RENDER (CRÍTICOS)
     =============================== */

  // 1️⃣ Frase base: SOLO variables simples (NUNCA metadata)
  const renderFraseBase = (evento) => {
    const actor = evento.actor_display || "Usuario";
    const eventoTexto = EVENTOS_HUMANOS[evento.evento] || evento.evento || "realizó una acción";

    let frase = (<><strong>{actor}</strong> {eventoTexto}</>);

    // Paciente (snapshot, si existe)
    if (evento.paciente_nombre) {
      const paciente = [
        evento.paciente_nombre,
        evento.paciente_apellido_paterno,
        evento.paciente_apellido_materno,
      ]
        .filter(Boolean)
        .join(" ");

      if (evento.evento === "PACIENTE_CREADO") {
        frase = (
            <>
            {frase} al paciente <strong className="auditoria-paciente">{paciente}</strong>
            </>
        );
        } else {
        frase = (
            <>
            {frase} del paciente <strong className="auditoria-paciente">{paciente}</strong>
            </>
        );  
      }
    }

    return frase;
  };

  // 2️⃣ Detalle opcional: SOLO metadata.campos_modificados
  const renderDetalleCambios = (metadata) => {
  if (
    !metadata ||
    !Array.isArray(metadata.campos_modificados) ||
    metadata.campos_modificados.length === 0
  ) {
    return null;
  }

  const camposHumanos = metadata.campos_modificados.map((campo) => {
    const texto = CAMPOS_HUMANOS[campo] || campo.replace(/_/g, " ");
    return texto.charAt(0).toUpperCase() + texto.slice(1).toLowerCase();
  });

  return `Cambió: ${camposHumanos.join(", ")}`;
};

  /* ===============================
     ESTADOS
     =============================== */

  if (loading) {
    return <p>Cargando auditoría...</p>;
  }

  if (error) {
    return <p>Error al cargar la auditoría.</p>;
  }

  if (eventos.length === 0) {
    return <p>No hay actividad registrada.</p>;
  }

  /* ===============================
     RENDER
     =============================== */

  return (
    <div className="auditoria-container">
    <h2>Auditoría de Actividad</h2>

      <ul className="auditoria-list">
        {eventos.map((evento, index) => {
          const fraseBase = renderFraseBase(evento);
          const detalleCambios =
          evento.evento === "CONFIG_RECETA_ACTUALIZADA"
            ? null
            : renderDetalleCambios(evento.metadata);

          return (
            <li key={index} className="auditoria-item">
            <div className="auditoria-frase">{fraseBase}</div>

              {detalleCambios && (
                <div className="auditoria-cambios">{detalleCambios}</div>
              )}

              <div className="auditoria-fecha">
              {new Date(evento.timestamp).toLocaleString()}
            </div>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default AuditoriaActividad;
